import React from "react"

const Border = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 177 85"
      preserveAspectRatio="none"
      fill="none"
      style={{ position: "absolute", top: 0, left: 0, zIndex: 3 }}
    >
      {/* Solid black backing stroke */}
      <path
        d="M0 1.5H159C167.837 1.5 175 8.66344 175 17.5V66.8333C175 75.6699 167.837 82.8333 159 82.8333H47.1402"
        stroke="#000000"
        strokeWidth="3"
        vectorEffect="non-scaling-stroke"
      />
      {/* Gradient stroke on top */}
      <path
        d="M0 1.5H159C167.837 1.5 175 8.66344 175 17.5V66.8333C175 75.6699 167.837 82.8333 159 82.8333H47.1402"
        stroke="url(#paint0_linear_40008054_28275)"
        strokeWidth="3"
        vectorEffect="non-scaling-stroke"
      />
      <defs>
        <linearGradient
          id="paint0_linear_40008054_28275"
          x1="179.094"
          y1="6.80435"
          x2="41.7692"
          y2="67.5527"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.209287" stopColor="#07DEFF" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Border
